import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import {Story,Services,Benefits} from './components/StoryServices';
import Process from './components/Process';
import Gallery from './components/Gallery';
import {Testimonials,Guarantee} from './components/Testimonials';
import {FAQ,Contact} from './components/FAQContact';
import Footer from './components/Footer';
import './App.css';
import './mobile.css';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Stats />
        <Story />
        <Services />
        <Benefits />
        <Process />
        <Gallery />
        <Testimonials />
        <Guarantee />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;